import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/strongHealthyHomes';
import Goals from './Goals';

const StrongHealthyHomes = ({ setGoalsView }) => {
  const [dataVisibility, setDataVisibility] = useState(false);
  const datapoint = useRef(null);

  const findDataVisibility = () => {
    if (!datapoint && !datapoint.current) {
      setDataVisibility(false);
      return;
    }
    const rect = datapoint.current.getBoundingClientRect();
    const bool = !(rect.y > window.innerHeight || rect.y < (rect.height * -1));
    setDataVisibility(bool);
  };

  useEffect(() => {
    window.addEventListener('scroll', findDataVisibility);

    return () => window.removeEventListener('scroll', findDataVisibility);
  }, []);

  const graphic = (
    <svg className="visual" viewBox="0 0 394 468" ref={datapoint}>
      <title>
        Home data
      </title>
      <g fill="none">
        <g transform="translate(-900 -5380)translate(0 4492)translate(900 888)">
          <g className={`row ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="210.6 467.9 220.1 467.9 220.1 458.4 210.6 458.4" />
            <polygon points="198.2 467.9 207.7 467.9 207.7 458.4 198.2 458.4" />
            <polygon points="185.8 467.9 195.3 467.9 195.3 458.4 185.8 458.4" />
            <polygon points="173.4 467.9 182.9 467.9 182.9 458.4 173.4 458.4" />
            <polygon points="161.1 467.9 170.5 467.9 170.5 458.4 161.1 458.4" />
            <polygon points="148.7 467.9 158.1 467.9 158.1 458.4 148.7 458.4" />
            <polygon points="136.3 467.9 145.8 467.9 145.8 458.4 136.3 458.4" />
            <polygon points="123.9 467.9 133.4 467.9 133.4 458.4 123.9 458.4" />
            <polygon points="384.1 467.9 393.5 467.9 393.5 458.4 384.1 458.4" />
            <polygon points="371.7 467.9 381.1 467.9 381.1 458.4 371.7 458.4" />
            <polygon points="359.3 467.9 368.8 467.9 368.8 458.4 359.3 458.4" />
            <polygon points="346.9 467.9 356.4 467.9 356.4 458.4 346.9 458.4" />
            <polygon points="334.5 467.9 344 467.9 344 458.4 334.5 458.4" />
            <polygon points="322.1 467.9 331.6 467.9 331.6 458.4 322.1 458.4" />
            <polygon points="309.7 467.9 319.2 467.9 319.2 458.4 309.7 458.4" />
            <polygon points="297.3 467.9 306.8 467.9 306.8 458.4 297.3 458.4" />
            <polygon points="284.9 467.9 294.4 467.9 294.4 458.4 284.9 458.4" />
            <polygon points="260.2 467.9 269.6 467.9 269.6 458.4 260.2 458.4" />
            <polygon points="272.6 467.9 282 467.9 282 458.4 272.6 458.4" />
            <polygon points="247.8 467.9 257.3 467.9 257.3 458.4 247.8 458.4" />
            <polygon points="235.4 467.9 244.9 467.9 244.9 458.4 235.4 458.4" />
            <polygon points="223 467.9 232.5 467.9 232.5 458.4 223 458.4" />
            <polygon points="111.5 467.9 121 467.9 121 458.4 111.5 458.4" />
            <polygon points="99.1 467.9 108.6 467.9 108.6 458.4 99.1 458.4" />
            <polygon points="24.8 467.9 34.3 467.9 34.3 458.4 24.8 458.4" />
            <polygon points="74.3 467.9 83.8 467.9 83.8 458.4 74.3 458.4" />
            <polygon points="86.7 467.9 96.2 467.9 96.2 458.4 86.7 458.4" />
            <polygon points="49.6 467.9 59 467.9 59 458.4 49.6 458.4" />
            <polygon points="61.9 467.9 71.4 467.9 71.4 458.4 61.9 458.4" />
            <polygon points="37.2 467.9 46.6 467.9 46.6 458.4 37.2 458.4" />
            <polygon points="12.4 467.9 21.9 467.9 21.9 458.4 12.4 458.4" />
            <polygon points="0 467.9 9.5 467.9 9.5 458.4 0 458.4" />
          </g>
          <g className={`row ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 455.5 393.5 455.5 393.5 446 384.1 446" />
            <polygon points="371.7 455.5 381.1 455.5 381.1 446 371.7 446" />
            <polygon points="359.3 455.5 368.8 455.5 368.8 446 359.3 446" />
            <polygon points="346.9 455.5 356.4 455.5 356.4 446 346.9 446" />
            <polygon points="334.5 455.5 344 455.5 344 446 334.5 446" />
            <polygon points="322.1 455.5 331.6 455.5 331.6 446 322.1 446" />
            <polygon points="309.7 455.5 319.2 455.5 319.2 446 309.7 446" />
            <polygon points="297.3 455.5 306.8 455.5 306.8 446 297.3 446" />
            <polygon points="284.9 455.5 294.4 455.5 294.4 446 284.9 446" />
            <polygon points="272.6 455.5 282 455.5 282 446 272.6 446" />
            <polygon points="260.2 455.5 269.6 455.5 269.6 446 260.2 446" />
            <polygon points="247.8 455.5 257.3 455.5 257.3 446 247.8 446" />
            <polygon points="235.4 455.5 244.9 455.5 244.9 446 235.4 446" />
            <polygon points="223 455.5 232.5 455.5 232.5 446 223 446" />
            <polygon points="111.5 455.5 121 455.5 121 446 111.5 446" />
            <polygon points="123.9 455.5 133.4 455.5 133.4 446 123.9 446" />
            <polygon points="136.3 455.5 145.8 455.5 145.8 446 136.3 446" />
            <polygon points="148.7 455.5 158.1 455.5 158.1 446 148.7 446" />
            <polygon points="210.6 455.5 220.1 455.5 220.1 446 210.6 446" />
            <polygon points="198.2 455.5 207.7 455.5 207.7 446 198.2 446" />
            <polygon points="185.8 455.5 195.3 455.5 195.3 446 185.8 446" />
            <polygon points="173.4 455.5 182.9 455.5 182.9 446 173.4 446" />
            <polygon points="161.1 455.5 170.5 455.5 170.5 446 161.1 446" />
            <polygon points="99.1 455.5 108.6 455.5 108.6 446 99.1 446" />
            <polygon points="86.7 455.5 96.2 455.5 96.2 446 86.7 446" />
            <polygon points="74.3 455.5 83.8 455.5 83.8 446 74.3 446" />
            <polygon points="61.9 455.5 71.4 455.5 71.4 446 61.9 446" />
            <polygon points="49.6 455.5 59 455.5 59 446 49.6 446" />
            <polygon points="37.2 455.5 46.6 455.5 46.6 446 37.2 446" />
            <polygon points="12.4 455.5 21.9 455.5 21.9 446 12.4 446" />
            <polygon points="0 455.5 9.5 455.5 9.5 446 0 446" />
            <polygon points="24.8 455.5 34.3 455.5 34.3 446 24.8 446" />
          </g>
          <g className={`row one ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 443.1 393.5 443.1 393.5 433.6 384.1 433.6" />
            <polygon points="371.7 443.1 381.1 443.1 381.1 433.6 371.7 433.6" />
            <polygon points="359.3 443.1 368.8 443.1 368.8 433.6 359.3 433.6" />
            <polygon points="346.9 443.1 356.4 443.1 356.4 433.6 346.9 433.6" />
            <polygon points="334.5 443.1 344 443.1 344 433.6 334.5 433.6" />
            <polygon points="322.1 443.1 331.6 443.1 331.6 433.6 322.1 433.6" />
            <polygon points="309.7 443.1 319.2 443.1 319.2 433.6 309.7 433.6" />
            <polygon points="297.3 443.1 306.8 443.1 306.8 433.6 297.3 433.6" />
            <polygon points="284.9 443.1 294.4 443.1 294.4 433.6 284.9 433.6" />
            <polygon points="272.6 443.1 282 443.1 282 433.6 272.6 433.6" />
            <polygon points="260.2 443.1 269.6 443.1 269.6 433.6 260.2 433.6" />
            <polygon points="247.8 443.1 257.3 443.1 257.3 433.6 247.8 433.6" />
            <polygon points="235.4 443.1 244.9 443.1 244.9 433.6 235.4 433.6" />
            <polygon points="223 443.1 232.5 443.1 232.5 433.6 223 433.6" />
            <polygon points="210.6 443.1 220.1 443.1 220.1 433.6 210.6 433.6" />
            <polygon points="198.2 443.1 207.7 443.1 207.7 433.6 198.2 433.6" />
            <polygon points="185.8 443.1 195.3 443.1 195.3 433.6 185.8 433.6" />
            <polygon points="173.4 443.1 182.9 443.1 182.9 433.6 173.4 433.6" />
            <polygon points="161.1 443.1 170.5 443.1 170.5 433.6 161.1 433.6" />
            <polygon points="148.7 443.1 158.1 443.1 158.1 433.6 148.7 433.6" />
            <polygon points="136.3 443.1 145.8 443.1 145.8 433.6 136.3 433.6" />
            <polygon points="123.9 443.1 133.4 443.1 133.4 433.6 123.9 433.6" />
            <polygon points="111.5 443.1 121 443.1 121 433.6 111.5 433.6" />
            <polygon points="99.1 443.1 108.6 443.1 108.6 433.6 99.1 433.6" />
            <polygon points="86.7 443.1 96.2 443.1 96.2 433.6 86.7 433.6" />
            <polygon points="74.3 443.1 83.8 443.1 83.8 433.6 74.3 433.6" />
            <polygon points="61.9 443.1 71.4 443.1 71.4 433.6 61.9 433.6" />
            <polygon points="49.6 443.1 59 443.1 59 433.6 49.6 433.6" />
            <polygon points="37.2 443.1 46.6 443.1 46.6 433.6 37.2 433.6" />
            <polygon points="24.8 443.1 34.3 443.1 34.3 433.6 24.8 433.6" />
            <polygon points="12.4 443.1 21.9 443.1 21.9 433.6 12.4 433.6" />
            <polygon points="0 443.1 9.5 443.1 9.5 433.6 0 433.6" />
          </g>
          <g className={`row two ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 430.7 393.5 430.7 393.5 421.2 384.1 421.2" />
            <polygon points="371.7 430.7 381.1 430.7 381.1 421.2 371.7 421.2" />
            <polygon points="359.3 430.7 368.8 430.7 368.8 421.2 359.3 421.2" />
            <polygon points="346.9 430.7 356.4 430.7 356.4 421.2 346.9 421.2" />
            <polygon points="334.5 430.7 344 430.7 344 421.2 334.5 421.2" />
            <polygon points="322.1 430.7 331.6 430.7 331.6 421.2 322.1 421.2" />
            <polygon points="309.7 430.7 319.2 430.7 319.2 421.2 309.7 421.2" />
            <polygon points="297.3 430.7 306.8 430.7 306.8 421.2 297.3 421.2" />
            <polygon points="284.9 430.7 294.4 430.7 294.4 421.2 284.9 421.2" />
            <polygon points="272.6 430.7 282 430.7 282 421.2 272.6 421.2" />
            <polygon points="260.2 430.7 269.6 430.7 269.6 421.2 260.2 421.2" />
            <polygon points="247.8 430.7 257.3 430.7 257.3 421.2 247.8 421.2" />
            <polygon points="235.4 430.7 244.9 430.7 244.9 421.2 235.4 421.2" />
            <polygon points="223 430.7 232.5 430.7 232.5 421.2 223 421.2" />
            <polygon points="210.6 430.7 220.1 430.7 220.1 421.2 210.6 421.2" />
            <polygon points="198.2 430.7 207.7 430.7 207.7 421.2 198.2 421.2" />
            <polygon points="185.8 430.7 195.3 430.7 195.3 421.2 185.8 421.2" />
            <polygon points="173.4 430.7 182.9 430.7 182.9 421.2 173.4 421.2" />
            <polygon points="161.1 430.7 170.5 430.7 170.5 421.2 161.1 421.2" />
            <polygon points="148.7 430.7 158.1 430.7 158.1 421.2 148.7 421.2" />
            <polygon points="136.3 430.7 145.8 430.7 145.8 421.2 136.3 421.2" />
            <polygon points="123.9 430.7 133.4 430.7 133.4 421.2 123.9 421.2" />
            <polygon points="111.5 430.7 121 430.7 121 421.2 111.5 421.2" />
            <polygon points="99.1 430.7 108.6 430.7 108.6 421.2 99.1 421.2" />
            <polygon points="86.7 430.7 96.2 430.7 96.2 421.2 86.7 421.2" />
            <polygon points="74.3 430.7 83.8 430.7 83.8 421.2 74.3 421.2" />
            <polygon points="61.9 430.7 71.4 430.7 71.4 421.2 61.9 421.2" />
            <polygon points="49.6 430.7 59 430.7 59 421.2 49.6 421.2" />
            <polygon points="37.2 430.7 46.6 430.7 46.6 421.2 37.2 421.2" />
            <polygon points="24.8 430.7 34.3 430.7 34.3 421.2 24.8 421.2" />
            <polygon points="12.4 430.7 21.9 430.7 21.9 421.2 12.4 421.2" />
            <polygon points="0 430.7 9.5 430.7 9.5 421.2 0 421.2" />
          </g>
          <g className={`row three ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 418.3 393.5 418.3 393.5 408.8 384.1 408.8" />
            <polygon points="371.7 418.3 381.1 418.3 381.1 408.8 371.7 408.8" />
            <polygon points="359.3 418.3 368.8 418.3 368.8 408.8 359.3 408.8" />
            <polygon points="346.9 418.3 356.4 418.3 356.4 408.8 346.9 408.8" />
            <polygon points="334.5 418.3 344 418.3 344 408.8 334.5 408.8" />
            <polygon points="322.1 418.3 331.6 418.3 331.6 408.8 322.1 408.8" />
            <polygon points="309.7 418.3 319.2 418.3 319.2 408.8 309.7 408.8" />
            <polygon points="297.3 418.3 306.8 418.3 306.8 408.8 297.3 408.8" />
            <polygon points="284.9 418.3 294.4 418.3 294.4 408.8 284.9 408.8" />
            <polygon points="272.6 418.3 282 418.3 282 408.8 272.6 408.8" />
            <polygon points="260.2 418.3 269.6 418.3 269.6 408.8 260.2 408.8" />
            <polygon points="247.8 418.3 257.3 418.3 257.3 408.8 247.8 408.8" />
            <polygon points="235.4 418.3 244.9 418.3 244.9 408.8 235.4 408.8" />
            <polygon points="223 418.3 232.5 418.3 232.5 408.8 223 408.8" />
            <polygon points="210.6 418.3 220.1 418.3 220.1 408.8 210.6 408.8" />
            <polygon points="198.2 418.3 207.7 418.3 207.7 408.8 198.2 408.8" />
            <polygon points="185.8 418.3 195.3 418.3 195.3 408.8 185.8 408.8" />
            <polygon points="173.4 418.3 182.9 418.3 182.9 408.8 173.4 408.8" />
            <polygon points="161.1 418.3 170.5 418.3 170.5 408.8 161.1 408.8" />
            <polygon points="148.7 418.3 158.1 418.3 158.1 408.8 148.7 408.8" />
            <polygon points="136.3 418.3 145.8 418.3 145.8 408.8 136.3 408.8" />
            <polygon points="123.9 418.3 133.4 418.3 133.4 408.8 123.9 408.8" />
            <polygon points="111.5 418.3 121 418.3 121 408.8 111.5 408.8" />
            <polygon points="99.1 418.3 108.6 418.3 108.6 408.8 99.1 408.8" />
            <polygon points="86.7 418.3 96.2 418.3 96.2 408.8 86.7 408.8" />
            <polygon points="74.3 418.3 83.8 418.3 83.8 408.8 74.3 408.8" />
            <polygon points="61.9 418.3 71.4 418.3 71.4 408.8 61.9 408.8" />
            <polygon points="49.6 418.3 59 418.3 59 408.8 49.6 408.8" />
            <polygon points="37.2 418.3 46.6 418.3 46.6 408.8 37.2 408.8" />
            <polygon points="24.8 418.3 34.3 418.3 34.3 408.8 24.8 408.8" />
            <polygon points="12.4 418.3 21.9 418.3 21.9 408.8 12.4 408.8" />
            <polygon points="0 418.3 9.5 418.3 9.5 408.8 0 408.8" />
          </g>
          <g className={`row four ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 405.9 393.5 405.9 393.5 396.4 384.1 396.4" />
            <polygon points="371.7 405.9 381.1 405.9 381.1 396.4 371.7 396.4" />
            <polygon points="359.3 405.9 368.8 405.9 368.8 396.4 359.3 396.4" />
            <polygon points="346.9 405.9 356.4 405.9 356.4 396.4 346.9 396.4" />
            <polygon points="334.5 405.9 344 405.9 344 396.4 334.5 396.4" />
            <polygon points="322.1 405.9 331.6 405.9 331.6 396.4 322.1 396.4" />
            <polygon points="309.7 405.9 319.2 405.9 319.2 396.4 309.7 396.4" />
            <polygon points="297.3 405.9 306.8 405.9 306.8 396.4 297.3 396.4" />
            <polygon points="284.9 405.9 294.4 405.9 294.4 396.4 284.9 396.4" />
            <polygon points="272.6 405.9 282 405.9 282 396.4 272.6 396.4" />
            <polygon points="260.2 405.9 269.6 405.9 269.6 396.4 260.2 396.4" />
            <polygon points="247.8 405.9 257.3 405.9 257.3 396.4 247.8 396.4" />
            <polygon points="235.4 405.9 244.9 405.9 244.9 396.4 235.4 396.4" />
            <polygon points="223 405.9 232.5 405.9 232.5 396.4 223 396.4" />
            <polygon points="210.6 405.9 220.1 405.9 220.1 396.4 210.6 396.4" />
            <polygon points="198.2 405.9 207.7 405.9 207.7 396.4 198.2 396.4" />
            <polygon points="185.8 405.9 195.3 405.9 195.3 396.4 185.8 396.4" />
            <polygon points="173.4 405.9 182.9 405.9 182.9 396.4 173.4 396.4" />
            <polygon points="161.1 405.9 170.5 405.9 170.5 396.4 161.1 396.4" />
            <polygon points="148.7 405.9 158.1 405.9 158.1 396.4 148.7 396.4" />
            <polygon points="136.3 405.9 145.8 405.9 145.8 396.4 136.3 396.4" />
            <polygon points="123.9 405.9 133.4 405.9 133.4 396.4 123.9 396.4" />
            <polygon points="111.5 405.9 121 405.9 121 396.4 111.5 396.4" />
            <polygon points="99.1 405.9 108.6 405.9 108.6 396.4 99.1 396.4" />
            <polygon points="86.7 405.9 96.2 405.9 96.2 396.4 86.7 396.4" />
            <polygon points="74.3 405.9 83.8 405.9 83.8 396.4 74.3 396.4" />
            <polygon points="61.9 405.9 71.4 405.9 71.4 396.4 61.9 396.4" />
            <polygon points="49.6 405.9 59 405.9 59 396.4 49.6 396.4" />
            <polygon points="37.2 405.9 46.6 405.9 46.6 396.4 37.2 396.4" />
            <polygon points="24.8 405.9 34.3 405.9 34.3 396.4 24.8 396.4" />
            <polygon points="12.4 405.9 21.9 405.9 21.9 396.4 12.4 396.4" />
            <polygon points="0 405.9 9.5 405.9 9.5 396.4 0 396.4" />
          </g>
          <g className={`row five ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 393.5 393.5 393.5 393.5 384.1 384.1 384.1" />
            <polygon points="371.7 393.5 381.1 393.5 381.1 384.1 371.7 384.1" />
            <polygon points="359.3 393.5 368.8 393.5 368.8 384.1 359.3 384.1" />
            <polygon points="346.9 393.5 356.4 393.5 356.4 384.1 346.9 384.1" />
            <polygon points="334.5 393.5 344 393.5 344 384.1 334.5 384.1" />
            <polygon points="322.1 393.5 331.6 393.5 331.6 384.1 322.1 384.1" />
            <polygon points="309.7 393.5 319.2 393.5 319.2 384.1 309.7 384.1" />
            <polygon points="297.3 393.5 306.8 393.5 306.8 384.1 297.3 384.1" />
            <polygon points="284.9 393.5 294.4 393.5 294.4 384.1 284.9 384.1" />
            <polygon points="272.6 393.5 282 393.5 282 384.1 272.6 384.1" />
            <polygon points="260.2 393.5 269.6 393.5 269.6 384.1 260.2 384.1" />
            <polygon points="247.8 393.5 257.3 393.5 257.3 384.1 247.8 384.1" />
            <polygon points="235.4 393.5 244.9 393.5 244.9 384.1 235.4 384.1" />
            <polygon points="223 393.5 232.5 393.5 232.5 384.1 223 384.1" />
            <polygon points="210.6 393.5 220.1 393.5 220.1 384.1 210.6 384.1" />
            <polygon points="198.2 393.5 207.7 393.5 207.7 384.1 198.2 384.1" />
            <polygon points="185.8 393.5 195.3 393.5 195.3 384.1 185.8 384.1" />
            <polygon points="173.4 393.5 182.9 393.5 182.9 384.1 173.4 384.1" />
            <polygon points="161.1 393.5 170.5 393.5 170.5 384.1 161.1 384.1" />
            <polygon points="148.7 393.5 158.1 393.5 158.1 384.1 148.7 384.1" />
            <polygon points="136.3 393.5 145.8 393.5 145.8 384.1 136.3 384.1" />
            <polygon points="123.9 393.5 133.4 393.5 133.4 384.1 123.9 384.1" />
            <polygon points="111.5 393.5 121 393.5 121 384.1 111.5 384.1" />
            <polygon points="99.1 393.5 108.6 393.5 108.6 384.1 99.1 384.1" />
            <polygon points="86.7 393.5 96.2 393.5 96.2 384.1 86.7 384.1" />
            <polygon points="74.3 393.5 83.8 393.5 83.8 384.1 74.3 384.1" />
            <polygon points="61.9 393.5 71.4 393.5 71.4 384.1 61.9 384.1" />
            <polygon points="49.6 393.5 59 393.5 59 384.1 49.6 384.1" />
            <polygon points="37.2 393.5 46.6 393.5 46.6 384.1 37.2 384.1" />
            <polygon points="24.8 393.5 34.3 393.5 34.3 384.1 24.8 384.1" />
            <polygon points="12.4 393.5 21.9 393.5 21.9 384.1 12.4 384.1" />
            <polygon points="0 393.5 9.5 393.5 9.5 384.1 0 384.1" />
          </g>
          <g className={`row six ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 381.1 393.5 381.1 393.5 371.7 384.1 371.7" />
            <polygon points="371.7 381.1 381.1 381.1 381.1 371.7 371.7 371.7" />
            <polygon points="359.3 381.1 368.8 381.1 368.8 371.7 359.3 371.7" />
            <polygon points="346.9 381.1 356.4 381.1 356.4 371.7 346.9 371.7" />
            <polygon points="334.5 381.1 344 381.1 344 371.7 334.5 371.7" />
            <polygon points="322.1 381.1 331.6 381.1 331.6 371.7 322.1 371.7" />
            <polygon points="309.7 381.1 319.2 381.1 319.2 371.7 309.7 371.7" />
            <polygon points="297.3 381.1 306.8 381.1 306.8 371.7 297.3 371.7" />
            <polygon points="284.9 381.1 294.4 381.1 294.4 371.7 284.9 371.7" />
            <polygon points="272.6 381.1 282 381.1 282 371.7 272.6 371.7" />
            <polygon points="260.2 381.1 269.6 381.1 269.6 371.7 260.2 371.7" />
            <polygon points="247.8 381.1 257.3 381.1 257.3 371.7 247.8 371.7" />
            <polygon points="235.4 381.1 244.9 381.1 244.9 371.7 235.4 371.7" />
            <polygon points="223 381.1 232.5 381.1 232.5 371.7 223 371.7" />
            <polygon points="210.6 381.1 220.1 381.1 220.1 371.7 210.6 371.7" />
            <polygon points="198.2 381.1 207.7 381.1 207.7 371.7 198.2 371.7" />
            <polygon points="185.8 381.1 195.3 381.1 195.3 371.7 185.8 371.7" />
            <polygon points="173.4 381.1 182.9 381.1 182.9 371.7 173.4 371.7" />
            <polygon points="161.1 381.1 170.5 381.1 170.5 371.7 161.1 371.7" />
            <polygon points="148.7 381.1 158.1 381.1 158.1 371.7 148.7 371.7" />
            <polygon points="136.3 381.1 145.8 381.1 145.8 371.7 136.3 371.7" />
            <polygon points="123.9 381.1 133.4 381.1 133.4 371.7 123.9 371.7" />
            <polygon points="111.5 381.1 121 381.1 121 371.7 111.5 371.7" />
            <polygon points="99.1 381.1 108.6 381.1 108.6 371.7 99.1 371.7" />
            <polygon points="86.7 381.1 96.2 381.1 96.2 371.7 86.7 371.7" />
            <polygon points="74.3 381.1 83.8 381.1 83.8 371.7 74.3 371.7" />
            <polygon points="61.9 381.1 71.4 381.1 71.4 371.7 61.9 371.7" />
            <polygon points="49.6 381.1 59 381.1 59 371.7 49.6 371.7" />
            <polygon points="37.2 381.1 46.6 381.1 46.6 371.7 37.2 371.7" />
            <polygon points="24.8 381.1 34.3 381.1 34.3 371.7 24.8 371.7" />
            <polygon points="12.4 381.1 21.9 381.1 21.9 371.7 12.4 371.7" />
            <polygon points="0 381.1 9.5 381.1 9.5 371.7 0 371.7" />
          </g>
          <g className={`row seven ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 368.8 393.5 368.8 393.5 359.3 384.1 359.3" />
            <polygon points="371.7 368.8 381.1 368.8 381.1 359.3 371.7 359.3" />
            <polygon points="359.3 368.8 368.8 368.8 368.8 359.3 359.3 359.3" />
            <polygon points="346.9 368.8 356.4 368.8 356.4 359.3 346.9 359.3" />
            <polygon points="334.5 368.8 344 368.8 344 359.3 334.5 359.3" />
            <polygon points="322.1 368.8 331.6 368.8 331.6 359.3 322.1 359.3" />
            <polygon points="309.7 368.8 319.2 368.8 319.2 359.3 309.7 359.3" />
            <polygon points="297.3 368.8 306.8 368.8 306.8 359.3 297.3 359.3" />
            <polygon points="284.9 368.8 294.4 368.8 294.4 359.3 284.9 359.3" />
            <polygon points="272.6 368.8 282 368.8 282 359.3 272.6 359.3" />
            <polygon points="260.2 368.8 269.6 368.8 269.6 359.3 260.2 359.3" />
            <polygon points="247.8 368.8 257.3 368.8 257.3 359.3 247.8 359.3" />
            <polygon points="235.4 368.8 244.9 368.8 244.9 359.3 235.4 359.3" />
            <polygon points="223 368.8 232.5 368.8 232.5 359.3 223 359.3" />
            <polygon points="210.6 368.8 220.1 368.8 220.1 359.3 210.6 359.3" />
            <polygon points="198.2 368.8 207.7 368.8 207.7 359.3 198.2 359.3" />
            <polygon points="185.8 368.8 195.3 368.8 195.3 359.3 185.8 359.3" />
            <polygon points="173.4 368.8 182.9 368.8 182.9 359.3 173.4 359.3" />
            <polygon points="161.1 368.8 170.5 368.8 170.5 359.3 161.1 359.3" />
            <polygon points="148.7 368.8 158.1 368.8 158.1 359.3 148.7 359.3" />
            <polygon points="136.3 368.8 145.8 368.8 145.8 359.3 136.3 359.3" />
            <polygon points="123.9 368.8 133.4 368.8 133.4 359.3 123.9 359.3" />
            <polygon points="111.5 368.8 121 368.8 121 359.3 111.5 359.3" />
            <polygon points="99.1 368.8 108.6 368.8 108.6 359.3 99.1 359.3" />
            <polygon points="86.7 368.8 96.2 368.8 96.2 359.3 86.7 359.3" />
            <polygon points="74.3 368.8 83.8 368.8 83.8 359.3 74.3 359.3" />
            <polygon points="61.9 368.8 71.4 368.8 71.4 359.3 61.9 359.3" />
            <polygon points="49.6 368.8 59 368.8 59 359.3 49.6 359.3" />
            <polygon points="37.2 368.8 46.6 368.8 46.6 359.3 37.2 359.3" />
            <polygon points="24.8 368.8 34.3 368.8 34.3 359.3 24.8 359.3" />
            <polygon points="12.4 368.8 21.9 368.8 21.9 359.3 12.4 359.3" />
            <polygon points="0 368.8 9.5 368.8 9.5 359.3 0 359.3" />
          </g>
          <g className={`row eight ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 356.4 393.5 356.4 393.5 346.9 384.1 346.9" />
            <polygon points="371.7 356.4 381.1 356.4 381.1 346.9 371.7 346.9" />
            <polygon points="359.3 356.4 368.8 356.4 368.8 346.9 359.3 346.9" />
            <polygon points="346.9 356.4 356.4 356.4 356.4 346.9 346.9 346.9" />
            <polygon points="334.5 356.4 344 356.4 344 346.9 334.5 346.9" />
            <polygon points="322.1 356.4 331.6 356.4 331.6 346.9 322.1 346.9" />
            <polygon points="309.7 356.4 319.2 356.4 319.2 346.9 309.7 346.9" />
            <polygon points="297.3 356.4 306.8 356.4 306.8 346.9 297.3 346.9" />
            <polygon points="284.9 356.4 294.4 356.4 294.4 346.9 284.9 346.9" />
            <polygon points="272.6 356.4 282 356.4 282 346.9 272.6 346.9" />
            <polygon points="260.2 356.4 269.6 356.4 269.6 346.9 260.2 346.9" />
            <polygon points="247.8 356.4 257.3 356.4 257.3 346.9 247.8 346.9" />
            <polygon points="235.4 356.4 244.9 356.4 244.9 346.9 235.4 346.9" />
            <polygon points="223 356.4 232.5 356.4 232.5 346.9 223 346.9" />
            <polygon points="210.6 356.4 220.1 356.4 220.1 346.9 210.6 346.9" />
            <polygon points="198.2 356.4 207.7 356.4 207.7 346.9 198.2 346.9" />
            <polygon points="185.8 356.4 195.3 356.4 195.3 346.9 185.8 346.9" />
            <polygon points="173.4 356.4 182.9 356.4 182.9 346.9 173.4 346.9" />
            <polygon points="161.1 356.4 170.5 356.4 170.5 346.9 161.1 346.9" />
            <polygon points="148.7 356.4 158.1 356.4 158.1 346.9 148.7 346.9" />
            <polygon points="136.3 356.4 145.8 356.4 145.8 346.9 136.3 346.9" />
            <polygon points="123.9 356.4 133.4 356.4 133.4 346.9 123.9 346.9" />
            <polygon points="111.5 356.4 121 356.4 121 346.9 111.5 346.9" />
            <polygon points="99.1 356.4 108.6 356.4 108.6 346.9 99.1 346.9" />
            <polygon points="86.7 356.4 96.2 356.4 96.2 346.9 86.7 346.9" />
            <polygon points="74.3 356.4 83.8 356.4 83.8 346.9 74.3 346.9" />
            <polygon points="61.9 356.4 71.4 356.4 71.4 346.9 61.9 346.9" />
            <polygon points="49.6 356.4 59 356.4 59 346.9 49.6 346.9" />
            <polygon points="37.2 356.4 46.6 356.4 46.6 346.9 37.2 346.9" />
            <polygon points="24.8 356.4 34.3 356.4 34.3 346.9 24.8 346.9" />
            <polygon points="12.4 356.4 21.9 356.4 21.9 346.9 12.4 346.9" />
            <polygon points="0 356.4 9.5 356.4 9.5 346.9 0 346.9" />
          </g>
          <g className={`row nine ${dataVisibility ? 'fill' : ''}`}>
            <polygon points="384.1 344 393.5 344 393.5 334.5 384.1 334.5" />
            <polygon points="371.7 344 381.1 344 381.1 334.5 371.7 334.5" />
            <polygon points="359.3 344 368.8 344 368.8 334.5 359.3 334.5" />
            <polygon points="346.9 344 356.4 344 356.4 334.5 346.9 334.5" />
            <polygon points="334.5 344 344 344 344 334.5 334.5 334.5" />
            <polygon points="322.1 344 331.6 344 331.6 334.5 322.1 334.5" />
            <polygon points="309.7 344 319.2 344 319.2 334.5 309.7 334.5" />
            <polygon points="297.3 344 306.8 344 306.8 334.5 297.3 334.5" />
            <polygon points="284.9 344 294.4 344 294.4 334.5 284.9 334.5" />
            <polygon points="272.6 344 282 344 282 334.5 272.6 334.5" />
            <polygon points="260.2 344 269.6 344 269.6 334.5 260.2 334.5" />
            <polygon points="247.8 344 257.3 344 257.3 334.5 247.8 334.5" />
            <polygon points="235.4 344 244.9 344 244.9 334.5 235.4 334.5" />
          </g>
          <polygon points="223 331.6 232.5 331.6 232.5 322.1 223 322.1" />
          <polygon points="210.6 331.6 220.1 331.6 220.1 322.1 210.6 322.1" />
          <polygon points="198.2 331.6 207.7 331.6 207.7 322.1 198.2 322.1" />
          <polygon points="185.8 331.6 195.3 331.6 195.3 322.1 185.8 322.1" />
          <polygon points="173.4 331.6 182.9 331.6 182.9 322.1 173.4 322.1" />
          <polygon points="161.1 331.6 170.5 331.6 170.5 322.1 161.1 322.1" />
          <polygon points="148.7 331.6 158.1 331.6 158.1 322.1 148.7 322.1" />
          <polygon points="136.3 331.6 145.8 331.6 145.8 322.1 136.3 322.1" />
          <polygon points="123.9 331.6 133.4 331.6 133.4 322.1 123.9 322.1" />
          <polygon points="111.5 331.6 121 331.6 121 322.1 111.5 322.1" />
          <polygon points="99.1 331.6 108.6 331.6 108.6 322.1 99.1 322.1" />
          <polygon points="86.7 331.6 96.2 331.6 96.2 322.1 86.7 322.1" />
          <polygon points="74.3 331.6 83.8 331.6 83.8 322.1 74.3 322.1" />
          <polygon points="61.9 331.6 71.4 331.6 71.4 322.1 61.9 322.1" />
          <polygon points="49.6 331.6 59 331.6 59 322.1 49.6 322.1" />
          <polygon points="37.2 331.6 46.6 331.6 46.6 322.1 37.2 322.1" />
          <polygon points="24.8 331.6 34.3 331.6 34.3 322.1 24.8 322.1" />
          <polygon points="12.4 331.6 21.9 331.6 21.9 322.1 12.4 322.1" />
          <polygon points="0 331.6 9.5 331.6 9.5 322.1 0 322.1" />
          <polygon points="223 344 232.5 344 232.5 334.5 223 334.5" />
          <polygon points="210.6 344 220.1 344 220.1 334.5 210.6 334.5" />
          <polygon points="198.2 344 207.7 344 207.7 334.5 198.2 334.5" />
          <polygon points="185.8 344 195.3 344 195.3 334.5 185.8 334.5" />
          <polygon points="173.4 344 182.9 344 182.9 334.5 173.4 334.5" />
          <polygon points="161.1 344 170.5 344 170.5 334.5 161.1 334.5" />
          <polygon points="148.7 344 158.1 344 158.1 334.5 148.7 334.5" />
          <polygon points="136.3 344 145.8 344 145.8 334.5 136.3 334.5" />
          <polygon points="123.9 344 133.4 344 133.4 334.5 123.9 334.5" />
          <polygon points="111.5 344 121 344 121 334.5 111.5 334.5" />
          <polygon points="99.1 344 108.6 344 108.6 334.5 99.1 334.5" />
          <polygon points="86.7 344 96.2 344 96.2 334.5 86.7 334.5" />
          <polygon points="74.3 344 83.8 344 83.8 334.5 74.3 334.5" />
          <polygon points="61.9 344 71.4 344 71.4 334.5 61.9 334.5" />
          <polygon points="49.6 344 59 344 59 334.5 49.6 334.5" />
          <polygon points="37.2 344 46.6 344 46.6 334.5 37.2 334.5" />
          <polygon points="24.8 344 34.3 344 34.3 334.5 24.8 334.5" />
          <polygon points="12.4 344 21.9 344 21.9 334.5 12.4 334.5" />
          <polygon points="0 344 9.5 344 9.5 334.5 0 334.5" />
          <polygon points="384.1 331.6 393.5 331.6 393.5 322.1 384.1 322.1" />
          <polygon points="371.7 331.6 381.1 331.6 381.1 322.1 371.7 322.1" />
          <polygon points="359.3 331.6 368.8 331.6 368.8 322.1 359.3 322.1" />
          <polygon points="346.9 331.6 356.4 331.6 356.4 322.1 346.9 322.1" />
          <polygon points="334.5 331.6 344 331.6 344 322.1 334.5 322.1" />
          <polygon points="322.1 331.6 331.6 331.6 331.6 322.1 322.1 322.1" />
          <polygon points="309.7 331.6 319.2 331.6 319.2 322.1 309.7 322.1" />
          <polygon points="297.3 331.6 306.8 331.6 306.8 322.1 297.3 322.1" />
          <polygon points="235.4 306.8 244.9 306.8 244.9 297.3 235.4 297.3" />
          <polygon points="272.6 306.8 282 306.8 282 297.3 272.6 297.3" />
          <polygon points="260.2 306.8 269.6 306.8 269.6 297.3 260.2 297.3" />
          <polygon points="247.8 306.8 257.3 306.8 257.3 297.3 247.8 297.3" />
          <polygon points="223 306.8 232.5 306.8 232.5 297.3 223 297.3" />
          <polygon points="210.6 306.8 220.1 306.8 220.1 297.3 210.6 297.3" />
          <polygon points="198.2 306.8 207.7 306.8 207.7 297.3 198.2 297.3" />
          <polygon points="185.8 306.8 195.3 306.8 195.3 297.3 185.8 297.3" />
          <polygon points="173.4 306.8 182.9 306.8 182.9 297.3 173.4 297.3" />
          <polygon points="161.1 306.8 170.5 306.8 170.5 297.3 161.1 297.3" />
          <polygon points="148.7 306.8 158.1 306.8 158.1 297.3 148.7 297.3" />
          <polygon points="136.3 306.8 145.8 306.8 145.8 297.3 136.3 297.3" />
          <polygon points="123.9 306.8 133.4 306.8 133.4 297.3 123.9 297.3" />
          <polygon points="111.5 306.8 121 306.8 121 297.3 111.5 297.3" />
          <polygon points="99.1 306.8 108.6 306.8 108.6 297.3 99.1 297.3" />
          <polygon points="86.7 306.8 96.2 306.8 96.2 297.3 86.7 297.3" />
          <polygon points="74.3 306.8 83.8 306.8 83.8 297.3 74.3 297.3" />
          <polygon points="61.9 306.8 71.4 306.8 71.4 297.3 61.9 297.3" />
          <polygon points="49.6 306.8 59 306.8 59 297.3 49.6 297.3" />
          <polygon points="37.2 306.8 46.6 306.8 46.6 297.3 37.2 297.3" />
          <polygon points="24.8 306.8 34.3 306.8 34.3 297.3 24.8 297.3" />
          <polygon points="12.4 306.8 21.9 306.8 21.9 297.3 12.4 297.3" />
          <polygon points="0 306.8 9.5 306.8 9.5 297.3 0 297.3" />
          <polygon points="284.9 331.6 294.4 331.6 294.4 322.1 284.9 322.1" />
          <polygon points="272.6 331.6 282 331.6 282 322.1 272.6 322.1" />
          <polygon points="260.2 331.6 269.6 331.6 269.6 322.1 260.2 322.1" />
          <polygon points="247.8 331.6 257.3 331.6 257.3 322.1 247.8 322.1" />
          <polygon points="235.4 331.6 244.9 331.6 244.9 322.1 235.4 322.1" />
          <polygon points="384.1 319.2 393.5 319.2 393.5 309.7 384.1 309.7" />
          <polygon points="371.7 319.2 381.1 319.2 381.1 309.7 371.7 309.7" />
          <polygon points="359.3 319.2 368.8 319.2 368.8 309.7 359.3 309.7" />
          <polygon points="346.9 319.2 356.4 319.2 356.4 309.7 346.9 309.7" />
          <polygon points="334.5 319.2 344 319.2 344 309.7 334.5 309.7" />
          <polygon points="322.1 319.2 331.6 319.2 331.6 309.7 322.1 309.7" />
          <polygon points="309.7 319.2 319.2 319.2 319.2 309.7 309.7 309.7" />
          <polygon points="297.3 319.2 306.8 319.2 306.8 309.7 297.3 309.7" />
          <polygon points="284.9 319.2 294.4 319.2 294.4 309.7 284.9 309.7" />
          <polygon points="272.6 319.2 282 319.2 282 309.7 272.6 309.7" />
          <polygon points="260.2 319.2 269.6 319.2 269.6 309.7 260.2 309.7" />
          <polygon points="247.8 319.2 257.3 319.2 257.3 309.7 247.8 309.7" />
          <polygon points="235.4 319.2 244.9 319.2 244.9 309.7 235.4 309.7" />
          <polygon points="223 319.2 232.5 319.2 232.5 309.7 223 309.7" />
          <polygon points="210.6 319.2 220.1 319.2 220.1 309.7 210.6 309.7" />
          <polygon points="198.2 319.2 207.7 319.2 207.7 309.7 198.2 309.7" />
          <polygon points="185.8 319.2 195.3 319.2 195.3 309.7 185.8 309.7" />
          <polygon points="173.4 319.2 182.9 319.2 182.9 309.7 173.4 309.7" />
          <polygon points="161.1 319.2 170.5 319.2 170.5 309.7 161.1 309.7" />
          <polygon points="148.7 319.2 158.1 319.2 158.1 309.7 148.7 309.7" />
          <polygon points="136.3 319.2 145.8 319.2 145.8 309.7 136.3 309.7" />
          <polygon points="123.9 319.2 133.4 319.2 133.4 309.7 123.9 309.7" />
          <polygon points="111.5 319.2 121 319.2 121 309.7 111.5 309.7" />
          <polygon points="99.1 319.2 108.6 319.2 108.6 309.7 99.1 309.7" />
          <polygon points="86.7 319.2 96.2 319.2 96.2 309.7 86.7 309.7" />
          <polygon points="74.3 319.2 83.8 319.2 83.8 309.7 74.3 309.7" />
          <polygon points="61.9 319.2 71.4 319.2 71.4 309.7 61.9 309.7" />
          <polygon points="49.6 319.2 59 319.2 59 309.7 49.6 309.7" />
          <polygon points="37.2 319.2 46.6 319.2 46.6 309.7 37.2 309.7" />
          <polygon points="24.8 319.2 34.3 319.2 34.3 309.7 24.8 309.7" />
          <polygon points="12.4 319.2 21.9 319.2 21.9 309.7 12.4 309.7" />
          <polygon points="0 319.2 9.5 319.2 9.5 309.7 0 309.7" />
          <polygon points="384.1 306.8 393.5 306.8 393.5 297.3 384.1 297.3" />
          <polygon points="371.7 306.8 381.1 306.8 381.1 297.3 371.7 297.3" />
          <polygon points="359.3 306.8 368.8 306.8 368.8 297.3 359.3 297.3" />
          <polygon points="346.9 306.8 356.4 306.8 356.4 297.3 346.9 297.3" />
          <polygon points="334.5 306.8 344 306.8 344 297.3 334.5 297.3" />
          <polygon points="322.1 306.8 331.6 306.8 331.6 297.3 322.1 297.3" />
          <polygon points="309.7 306.8 319.2 306.8 319.2 297.3 309.7 297.3" />
          <polygon points="297.3 306.8 306.8 306.8 306.8 297.3 297.3 297.3" />
          <polygon points="284.9 306.8 294.4 306.8 294.4 297.3 284.9 297.3" />
          <polygon points="384.1 294.4 393.5 294.4 393.5 284.9 384.1 284.9" />
          <polygon points="371.7 294.4 381.1 294.4 381.1 284.9 371.7 284.9" />
          <polygon points="359.3 294.4 368.8 294.4 368.8 284.9 359.3 284.9" />
          <polygon points="346.9 294.4 356.4 294.4 356.4 284.9 346.9 284.9" />
          <polygon points="334.5 294.4 344 294.4 344 284.9 334.5 284.9" />
          <polygon points="322.1 294.4 331.6 294.4 331.6 284.9 322.1 284.9" />
          <polygon points="309.7 294.4 319.2 294.4 319.2 284.9 309.7 284.9" />
          <polygon points="297.3 294.4 306.8 294.4 306.8 284.9 297.3 284.9" />
          <polygon points="284.9 294.4 294.4 294.4 294.4 284.9 284.9 284.9" />
          <polygon points="272.6 294.4 282 294.4 282 284.9 272.6 284.9" />
          <polygon points="260.2 294.4 269.6 294.4 269.6 284.9 260.2 284.9" />
          <polygon points="247.8 294.4 257.3 294.4 257.3 284.9 247.8 284.9" />
          <polygon points="235.4 294.4 244.9 294.4 244.9 284.9 235.4 284.9" />
          <polygon points="223 294.4 232.5 294.4 232.5 284.9 223 284.9" />
          <polygon points="210.6 294.4 220.1 294.4 220.1 284.9 210.6 284.9" />
          <polygon points="198.2 294.4 207.7 294.4 207.7 284.9 198.2 284.9" />
          <polygon points="185.8 294.4 195.3 294.4 195.3 284.9 185.8 284.9" />
          <polygon points="173.4 294.4 182.9 294.4 182.9 284.9 173.4 284.9" />
          <polygon points="161.1 294.4 170.5 294.4 170.5 284.9 161.1 284.9" />
          <polygon points="148.7 294.4 158.1 294.4 158.1 284.9 148.7 284.9" />
          <polygon points="136.3 294.4 145.8 294.4 145.8 284.9 136.3 284.9" />
          <polygon points="123.9 294.4 133.4 294.4 133.4 284.9 123.9 284.9" />
          <polygon points="111.5 294.4 121 294.4 121 284.9 111.5 284.9" />
          <polygon points="99.1 294.4 108.6 294.4 108.6 284.9 99.1 284.9" />
          <polygon points="86.7 294.4 96.2 294.4 96.2 284.9 86.7 284.9" />
          <polygon points="74.3 294.4 83.8 294.4 83.8 284.9 74.3 284.9" />
          <polygon points="61.9 294.4 71.4 294.4 71.4 284.9 61.9 284.9" />
          <polygon points="49.6 294.4 59 294.4 59 284.9 49.6 284.9" />
          <polygon points="37.2 294.4 46.6 294.4 46.6 284.9 37.2 284.9" />
          <polygon points="24.8 294.4 34.3 294.4 34.3 284.9 24.8 284.9" />
          <polygon points="12.4 294.4 21.9 294.4 21.9 284.9 12.4 284.9" />
          <polygon points="0 294.4 9.5 294.4 9.5 284.9 0 284.9" />
          <polygon points="384.1 282 393.5 282 393.5 272.6 384.1 272.6" />
          <polygon points="371.7 282 381.1 282 381.1 272.6 371.7 272.6" />
          <polygon points="359.3 282 368.8 282 368.8 272.6 359.3 272.6" />
          <polygon points="346.9 282 356.4 282 356.4 272.6 346.9 272.6" />
          <polygon points="334.5 282 344 282 344 272.6 334.5 272.6" />
          <polygon points="322.1 282 331.6 282 331.6 272.6 322.1 272.6" />
          <polygon points="309.7 282 319.2 282 319.2 272.6 309.7 272.6" />
          <polygon points="297.3 282 306.8 282 306.8 272.6 297.3 272.6" />
          <polygon points="284.9 282 294.4 282 294.4 272.6 284.9 272.6" />
          <polygon points="272.6 282 282 282 282 272.6 272.6 272.6" />
          <polygon points="260.2 282 269.6 282 269.6 272.6 260.2 272.6" />
          <polygon points="247.8 282 257.3 282 257.3 272.6 247.8 272.6" />
          <polygon points="235.4 282 244.9 282 244.9 272.6 235.4 272.6" />
          <polygon points="223 282 232.5 282 232.5 272.6 223 272.6" />
          <polygon points="210.6 282 220.1 282 220.1 272.6 210.6 272.6" />
          <polygon points="198.2 282 207.7 282 207.7 272.6 198.2 272.6" />
          <polygon points="185.8 282 195.3 282 195.3 272.6 185.8 272.6" />
          <polygon points="173.4 282 182.9 282 182.9 272.6 173.4 272.6" />
          <polygon points="161.1 282 170.5 282 170.5 272.6 161.1 272.6" />
          <polygon points="148.7 282 158.1 282 158.1 272.6 148.7 272.6" />
          <polygon points="136.3 282 145.8 282 145.8 272.6 136.3 272.6" />
          <polygon points="123.9 282 133.4 282 133.4 272.6 123.9 272.6" />
          <polygon points="111.5 282 121 282 121 272.6 111.5 272.6" />
          <polygon points="99.1 282 108.6 282 108.6 272.6 99.1 272.6" />
          <polygon points="86.7 282 96.2 282 96.2 272.6 86.7 272.6" />
          <polygon points="74.3 282 83.8 282 83.8 272.6 74.3 272.6" />
          <polygon points="61.9 282 71.4 282 71.4 272.6 61.9 272.6" />
          <polygon points="49.6 282 59 282 59 272.6 49.6 272.6" />
          <polygon points="37.2 282 46.6 282 46.6 272.6 37.2 272.6" />
          <polygon points="24.8 282 34.3 282 34.3 272.6 24.8 272.6" />
          <polygon points="12.4 282 21.9 282 21.9 272.6 12.4 272.6" />
          <polygon points="0 282 9.5 282 9.5 272.6 0 272.6" />
          <polygon points="384.1 269.6 393.5 269.6 393.5 260.2 384.1 260.2" />
          <polygon points="371.7 269.6 381.1 269.6 381.1 260.2 371.7 260.2" />
          <polygon points="359.3 269.6 368.8 269.6 368.8 260.2 359.3 260.2" />
          <polygon points="346.9 269.6 356.4 269.6 356.4 260.2 346.9 260.2" />
          <polygon points="334.5 269.6 344 269.6 344 260.2 334.5 260.2" />
          <polygon points="322.1 269.6 331.6 269.6 331.6 260.2 322.1 260.2" />
          <polygon points="309.7 269.6 319.2 269.6 319.2 260.2 309.7 260.2" />
          <polygon points="297.3 269.6 306.8 269.6 306.8 260.2 297.3 260.2" />
          <polygon points="284.9 269.6 294.4 269.6 294.4 260.2 284.9 260.2" />
          <polygon points="272.6 269.6 282 269.6 282 260.2 272.6 260.2" />
          <polygon points="260.2 269.6 269.6 269.6 269.6 260.2 260.2 260.2" />
          <polygon points="247.8 269.6 257.3 269.6 257.3 260.2 247.8 260.2" />
          <polygon points="235.4 269.6 244.9 269.6 244.9 260.2 235.4 260.2" />
          <polygon points="223 269.6 232.5 269.6 232.5 260.2 223 260.2" />
          <polygon points="210.6 269.6 220.1 269.6 220.1 260.2 210.6 260.2" />
          <polygon points="198.2 269.6 207.7 269.6 207.7 260.2 198.2 260.2" />
          <polygon points="185.8 269.6 195.3 269.6 195.3 260.2 185.8 260.2" />
          <polygon points="173.4 269.6 182.9 269.6 182.9 260.2 173.4 260.2" />
          <polygon points="161.1 269.6 170.5 269.6 170.5 260.2 161.1 260.2" />
          <polygon points="148.7 269.6 158.1 269.6 158.1 260.2 148.7 260.2" />
          <polygon points="136.3 269.6 145.8 269.6 145.8 260.2 136.3 260.2" />
          <polygon points="123.9 269.6 133.4 269.6 133.4 260.2 123.9 260.2" />
          <polygon points="111.5 269.6 121 269.6 121 260.2 111.5 260.2" />
          <polygon points="99.1 269.6 108.6 269.6 108.6 260.2 99.1 260.2" />
          <polygon points="86.7 269.6 96.2 269.6 96.2 260.2 86.7 260.2" />
          <polygon points="74.3 269.6 83.8 269.6 83.8 260.2 74.3 260.2" />
          <polygon points="61.9 269.6 71.4 269.6 71.4 260.2 61.9 260.2" />
          <polygon points="49.6 269.6 59 269.6 59 260.2 49.6 260.2" />
          <polygon points="37.2 269.6 46.6 269.6 46.6 260.2 37.2 260.2" />
          <polygon points="24.8 269.6 34.3 269.6 34.3 260.2 24.8 260.2" />
          <polygon points="12.4 269.6 21.9 269.6 21.9 260.2 12.4 260.2" />
          <polygon points="0 269.6 9.5 269.6 9.5 260.2 0 260.2" />
          <polygon points="384.1 257.3 393.5 257.3 393.5 247.8 384.1 247.8" />
          <polygon points="371.7 257.3 381.1 257.3 381.1 247.8 371.7 247.8" />
          <polygon points="359.3 257.3 368.8 257.3 368.8 247.8 359.3 247.8" />
          <polygon points="346.9 257.3 356.4 257.3 356.4 247.8 346.9 247.8" />
          <polygon points="334.5 257.3 344 257.3 344 247.8 334.5 247.8" />
          <polygon points="322.1 257.3 331.6 257.3 331.6 247.8 322.1 247.8" />
          <polygon points="309.7 257.3 319.2 257.3 319.2 247.8 309.7 247.8" />
          <polygon points="297.3 257.3 306.8 257.3 306.8 247.8 297.3 247.8" />
          <polygon points="284.9 257.3 294.4 257.3 294.4 247.8 284.9 247.8" />
          <polygon points="272.6 257.3 282 257.3 282 247.8 272.6 247.8" />
          <polygon points="260.2 257.3 269.6 257.3 269.6 247.8 260.2 247.8" />
          <polygon points="247.8 257.3 257.3 257.3 257.3 247.8 247.8 247.8" />
          <polygon points="235.4 257.3 244.9 257.3 244.9 247.8 235.4 247.8" />
          <polygon points="223 257.3 232.5 257.3 232.5 247.8 223 247.8" />
          <polygon points="210.6 257.3 220.1 257.3 220.1 247.8 210.6 247.8" />
          <polygon points="198.2 257.3 207.7 257.3 207.7 247.8 198.2 247.8" />
          <polygon points="185.8 257.3 195.3 257.3 195.3 247.8 185.8 247.8" />
          <polygon points="173.4 257.3 182.9 257.3 182.9 247.8 173.4 247.8" />
          <polygon points="161.1 257.3 170.5 257.3 170.5 247.8 161.1 247.8" />
          <polygon points="148.7 257.3 158.1 257.3 158.1 247.8 148.7 247.8" />
          <polygon points="136.3 257.3 145.8 257.3 145.8 247.8 136.3 247.8" />
          <polygon points="123.9 257.3 133.4 257.3 133.4 247.8 123.9 247.8" />
          <polygon points="111.5 257.3 121 257.3 121 247.8 111.5 247.8" />
          <polygon points="99.1 257.3 108.6 257.3 108.6 247.8 99.1 247.8" />
          <polygon points="86.7 257.3 96.2 257.3 96.2 247.8 86.7 247.8" />
          <polygon points="74.3 257.3 83.8 257.3 83.8 247.8 74.3 247.8" />
          <polygon points="61.9 257.3 71.4 257.3 71.4 247.8 61.9 247.8" />
          <polygon points="49.6 257.3 59 257.3 59 247.8 49.6 247.8" />
          <polygon points="37.2 257.3 46.6 257.3 46.6 247.8 37.2 247.8" />
          <polygon points="24.8 257.3 34.3 257.3 34.3 247.8 24.8 247.8" />
          <polygon points="12.4 257.3 21.9 257.3 21.9 247.8 12.4 247.8" />
          <polygon points="0 257.3 9.5 257.3 9.5 247.8 0 247.8" />
          <polygon points="384.1 244.9 393.5 244.9 393.5 235.4 384.1 235.4" />
          <polygon points="371.7 244.9 381.1 244.9 381.1 235.4 371.7 235.4" />
          <polygon points="359.3 244.9 368.8 244.9 368.8 235.4 359.3 235.4" />
          <polygon points="346.9 244.9 356.4 244.9 356.4 235.4 346.9 235.4" />
          <polygon points="334.5 244.9 344 244.9 344 235.4 334.5 235.4" />
          <polygon points="322.1 244.9 331.6 244.9 331.6 235.4 322.1 235.4" />
          <polygon points="309.7 244.9 319.2 244.9 319.2 235.4 309.7 235.4" />
          <polygon points="297.3 244.9 306.8 244.9 306.8 235.4 297.3 235.4" />
          <polygon points="284.9 244.9 294.4 244.9 294.4 235.4 284.9 235.4" />
          <polygon points="272.6 244.9 282 244.9 282 235.4 272.6 235.4" />
          <polygon points="260.2 244.9 269.6 244.9 269.6 235.4 260.2 235.4" />
          <polygon points="247.8 244.9 257.3 244.9 257.3 235.4 247.8 235.4" />
          <polygon points="235.4 244.9 244.9 244.9 244.9 235.4 235.4 235.4" />
          <polygon points="223 244.9 232.5 244.9 232.5 235.4 223 235.4" />
          <polygon points="210.6 244.9 220.1 244.9 220.1 235.4 210.6 235.4" />
          <polygon points="198.2 244.9 207.7 244.9 207.7 235.4 198.2 235.4" />
          <polygon points="185.8 244.9 195.3 244.9 195.3 235.4 185.8 235.4" />
          <polygon points="173.4 244.9 182.9 244.9 182.9 235.4 173.4 235.4" />
          <polygon points="161.1 244.9 170.5 244.9 170.5 235.4 161.1 235.4" />
          <polygon points="148.7 244.9 158.1 244.9 158.1 235.4 148.7 235.4" />
          <polygon points="136.3 244.9 145.8 244.9 145.8 235.4 136.3 235.4" />
          <polygon points="123.9 244.9 133.4 244.9 133.4 235.4 123.9 235.4" />
          <polygon points="111.5 244.9 121 244.9 121 235.4 111.5 235.4" />
          <polygon points="99.1 244.9 108.6 244.9 108.6 235.4 99.1 235.4" />
          <polygon points="86.7 244.9 96.2 244.9 96.2 235.4 86.7 235.4" />
          <polygon points="74.3 244.9 83.8 244.9 83.8 235.4 74.3 235.4" />
          <polygon points="61.9 244.9 71.4 244.9 71.4 235.4 61.9 235.4" />
          <polygon points="49.6 244.9 59 244.9 59 235.4 49.6 235.4" />
          <polygon points="37.2 244.9 46.6 244.9 46.6 235.4 37.2 235.4" />
          <polygon points="24.8 244.9 34.3 244.9 34.3 235.4 24.8 235.4" />
          <polygon points="12.4 244.9 21.9 244.9 21.9 235.4 12.4 235.4" />
          <polygon points="0 244.9 9.5 244.9 9.5 235.4 0 235.4" />
          <polygon points="384.1 232.5 393.5 232.5 393.5 223 384.1 223" />
          <polygon points="371.7 232.5 381.1 232.5 381.1 223 371.7 223" />
          <polygon points="359.3 232.5 368.8 232.5 368.8 223 359.3 223" />
          <polygon points="346.9 232.5 356.4 232.5 356.4 223 346.9 223" />
          <polygon points="334.5 232.5 344 232.5 344 223 334.5 223" />
          <polygon points="322.1 232.5 331.6 232.5 331.6 223 322.1 223" />
          <polygon points="309.7 232.5 319.2 232.5 319.2 223 309.7 223" />
          <polygon points="297.3 232.5 306.8 232.5 306.8 223 297.3 223" />
          <polygon points="284.9 232.5 294.4 232.5 294.4 223 284.9 223" />
          <polygon points="272.6 232.5 282 232.5 282 223 272.6 223" />
          <polygon points="260.2 232.5 269.6 232.5 269.6 223 260.2 223" />
          <polygon points="247.8 232.5 257.3 232.5 257.3 223 247.8 223" />
          <polygon points="235.4 232.5 244.9 232.5 244.9 223 235.4 223" />
          <polygon points="223 232.5 232.5 232.5 232.5 223 223 223" />
          <polygon points="210.6 232.5 220.1 232.5 220.1 223 210.6 223" />
          <polygon points="198.2 232.5 207.7 232.5 207.7 223 198.2 223" />
          <polygon points="185.8 232.5 195.3 232.5 195.3 223 185.8 223" />
          <polygon points="173.4 232.5 182.9 232.5 182.9 223 173.4 223" />
          <polygon points="161.1 232.5 170.5 232.5 170.5 223 161.1 223" />
          <polygon points="148.7 232.5 158.1 232.5 158.1 223 148.7 223" />
          <polygon points="136.3 232.5 145.8 232.5 145.8 223 136.3 223" />
          <polygon points="123.9 232.5 133.4 232.5 133.4 223 123.9 223" />
          <polygon points="111.5 232.5 121 232.5 121 223 111.5 223" />
          <polygon points="99.1 232.5 108.6 232.5 108.6 223 99.1 223" />
          <polygon points="86.7 232.5 96.2 232.5 96.2 223 86.7 223" />
          <polygon points="74.3 232.5 83.8 232.5 83.8 223 74.3 223" />
          <polygon points="61.9 232.5 71.4 232.5 71.4 223 61.9 223" />
          <polygon points="49.6 232.5 59 232.5 59 223 49.6 223" />
          <polygon points="37.2 232.5 46.6 232.5 46.6 223 37.2 223" />
          <polygon points="24.8 232.5 34.3 232.5 34.3 223 24.8 223" />
          <polygon points="12.4 232.5 21.9 232.5 21.9 223 12.4 223" />
          <polygon points="0 232.5 9.5 232.5 9.5 223 0 223" />
          <polygon points="384.1 220.1 393.5 220.1 393.5 210.6 384.1 210.6" />
          <polygon points="371.7 220.1 381.1 220.1 381.1 210.6 371.7 210.6" />
          <polygon points="359.3 220.1 368.8 220.1 368.8 210.6 359.3 210.6" />
          <polygon points="346.9 220.1 356.4 220.1 356.4 210.6 346.9 210.6" />
          <polygon points="334.5 220.1 344 220.1 344 210.6 334.5 210.6" />
          <polygon points="322.1 220.1 331.6 220.1 331.6 210.6 322.1 210.6" />
          <polygon points="309.7 220.1 319.2 220.1 319.2 210.6 309.7 210.6" />
          <polygon points="297.3 220.1 306.8 220.1 306.8 210.6 297.3 210.6" />
          <polygon points="284.9 220.1 294.4 220.1 294.4 210.6 284.9 210.6" />
          <polygon points="272.6 220.1 282 220.1 282 210.6 272.6 210.6" />
          <polygon points="260.2 220.1 269.6 220.1 269.6 210.6 260.2 210.6" />
          <polygon points="247.8 220.1 257.3 220.1 257.3 210.6 247.8 210.6" />
          <polygon points="235.4 220.1 244.9 220.1 244.9 210.6 235.4 210.6" />
          <polygon points="223 220.1 232.5 220.1 232.5 210.6 223 210.6" />
          <polygon points="210.6 220.1 220.1 220.1 220.1 210.6 210.6 210.6" />
          <polygon points="198.2 220.1 207.7 220.1 207.7 210.6 198.2 210.6" />
          <polygon points="185.8 220.1 195.3 220.1 195.3 210.6 185.8 210.6" />
          <polygon points="173.4 220.1 182.9 220.1 182.9 210.6 173.4 210.6" />
          <polygon points="161.1 220.1 170.5 220.1 170.5 210.6 161.1 210.6" />
          <polygon points="148.7 220.1 158.1 220.1 158.1 210.6 148.7 210.6" />
          <polygon points="136.3 220.1 145.8 220.1 145.8 210.6 136.3 210.6" />
          <polygon points="123.9 220.1 133.4 220.1 133.4 210.6 123.9 210.6" />
          <polygon points="111.5 220.1 121 220.1 121 210.6 111.5 210.6" />
          <polygon points="99.1 220.1 108.6 220.1 108.6 210.6 99.1 210.6" />
          <polygon points="86.7 220.1 96.2 220.1 96.2 210.6 86.7 210.6" />
          <polygon points="74.3 220.1 83.8 220.1 83.8 210.6 74.3 210.6" />
          <polygon points="61.9 220.1 71.4 220.1 71.4 210.6 61.9 210.6" />
          <polygon points="49.6 220.1 59 220.1 59 210.6 49.6 210.6" />
          <polygon points="37.2 220.1 46.6 220.1 46.6 210.6 37.2 210.6" />
          <polygon points="24.8 220.1 34.3 220.1 34.3 210.6 24.8 210.6" />
          <polygon points="12.4 220.1 21.9 220.1 21.9 210.6 12.4 210.6" />
          <polygon points="0 220.1 9.5 220.1 9.5 210.6 0 210.6" />
          <polygon points="384.1 207.7 393.5 207.7 393.5 198.2 384.1 198.2" />
          <polygon points="384.1 195.3 393.5 195.3 393.5 185.8 384.1 185.8" />
          <polygon points="384.1 182.9 393.5 182.9 393.5 173.4 384.1 173.4" />
          <polygon points="371.7 207.7 381.1 207.7 381.1 198.2 371.7 198.2" />
          <polygon points="371.7 195.3 381.1 195.3 381.1 185.8 371.7 185.8" />
          <polygon points="371.7 182.9 381.1 182.9 381.1 173.4 371.7 173.4" />
          <polygon points="371.7 170.5 381.1 170.5 381.1 161.1 371.7 161.1" />
          <polygon points="359.3 207.7 368.8 207.7 368.8 198.2 359.3 198.2" />
          <polygon points="359.3 195.3 368.8 195.3 368.8 185.8 359.3 185.8" />
          <polygon points="359.3 182.9 368.8 182.9 368.8 173.4 359.3 173.4" />
          <polygon points="359.3 170.5 368.8 170.5 368.8 161.1 359.3 161.1" />
          <polygon points="359.3 158.1 368.8 158.1 368.8 148.7 359.3 148.7" />
          <polygon points="346.9 207.7 356.4 207.7 356.4 198.2 346.9 198.2" />
          <polygon points="346.9 195.3 356.4 195.3 356.4 185.8 346.9 185.8" />
          <polygon points="346.9 182.9 356.4 182.9 356.4 173.4 346.9 173.4" />
          <polygon points="346.9 170.5 356.4 170.5 356.4 161.1 346.9 161.1" />
          <polygon points="346.9 158.1 356.4 158.1 356.4 148.7 346.9 148.7" />
          <polygon points="346.9 145.8 356.4 145.8 356.4 136.3 346.9 136.3" />
          <polygon points="334.5 207.7 344 207.7 344 198.2 334.5 198.2" />
          <polygon points="334.5 195.3 344 195.3 344 185.8 334.5 185.8" />
          <polygon points="334.5 182.9 344 182.9 344 173.4 334.5 173.4" />
          <polygon points="334.5 170.5 344 170.5 344 161.1 334.5 161.1" />
          <polygon points="334.5 158.1 344 158.1 344 148.7 334.5 148.7" />
          <polygon points="334.5 145.8 344 145.8 344 136.3 334.5 136.3" />
          <polygon points="334.5 133.4 344 133.4 344 123.9 334.5 123.9" />
          <polygon points="322.1 207.7 331.6 207.7 331.6 198.2 322.1 198.2" />
          <polygon points="322.1 195.3 331.6 195.3 331.6 185.8 322.1 185.8" />
          <polygon points="322.1 182.9 331.6 182.9 331.6 173.4 322.1 173.4" />
          <polygon points="322.1 170.5 331.6 170.5 331.6 161.1 322.1 161.1" />
          <polygon points="322.1 158.1 331.6 158.1 331.6 148.7 322.1 148.7" />
          <polygon points="322.1 145.8 331.6 145.8 331.6 136.3 322.1 136.3" />
          <polygon points="322.1 133.4 331.6 133.4 331.6 123.9 322.1 123.9" />
          <polygon points="322.1 121 331.6 121 331.6 111.5 322.1 111.5" />
          <polygon points="309.7 207.7 319.2 207.7 319.2 198.2 309.7 198.2" />
          <polygon points="309.7 195.3 319.2 195.3 319.2 185.8 309.7 185.8" />
          <polygon points="309.7 182.9 319.2 182.9 319.2 173.4 309.7 173.4" />
          <polygon points="309.7 170.5 319.2 170.5 319.2 161.1 309.7 161.1" />
          <polygon points="309.7 158.1 319.2 158.1 319.2 148.7 309.7 148.7" />
          <polygon points="309.7 145.8 319.2 145.8 319.2 136.3 309.7 136.3" />
          <polygon points="309.7 133.4 319.2 133.4 319.2 123.9 309.7 123.9" />
          <polygon points="309.7 121 319.2 121 319.2 111.5 309.7 111.5" />
          <polygon points="309.7 108.6 319.2 108.6 319.2 99.1 309.7 99.1" />
          <polygon points="297.3 207.7 306.8 207.7 306.8 198.2 297.3 198.2" />
          <polygon points="297.3 195.3 306.8 195.3 306.8 185.8 297.3 185.8" />
          <polygon points="297.3 182.9 306.8 182.9 306.8 173.4 297.3 173.4" />
          <polygon points="297.3 170.5 306.8 170.5 306.8 161.1 297.3 161.1" />
          <polygon points="297.3 158.1 306.8 158.1 306.8 148.7 297.3 148.7" />
          <polygon points="297.3 145.8 306.8 145.8 306.8 136.3 297.3 136.3" />
          <polygon points="297.3 133.4 306.8 133.4 306.8 123.9 297.3 123.9" />
          <polygon points="297.3 121 306.8 121 306.8 111.5 297.3 111.5" />
          <polygon points="297.3 108.6 306.8 108.6 306.8 99.1 297.3 99.1" />
          <polygon points="297.3 96.2 306.8 96.2 306.8 86.7 297.3 86.7" />
          <polygon points="284.9 207.7 294.4 207.7 294.4 198.2 284.9 198.2" />
          <polygon points="284.9 195.3 294.4 195.3 294.4 185.8 284.9 185.8" />
          <polygon points="284.9 182.9 294.4 182.9 294.4 173.4 284.9 173.4" />
          <polygon points="284.9 170.5 294.4 170.5 294.4 161.1 284.9 161.1" />
          <polygon points="284.9 158.1 294.4 158.1 294.4 148.7 284.9 148.7" />
          <polygon points="284.9 145.8 294.4 145.8 294.4 136.3 284.9 136.3" />
          <polygon points="284.9 133.4 294.4 133.4 294.4 123.9 284.9 123.9" />
          <polygon points="284.9 121 294.4 121 294.4 111.5 284.9 111.5" />
          <polygon points="284.9 108.6 294.4 108.6 294.4 99.1 284.9 99.1" />
          <polygon points="284.9 96.2 294.4 96.2 294.4 86.7 284.9 86.7" />
          <polygon points="272.6 207.7 282 207.7 282 198.2 272.6 198.2" />
          <polygon points="272.6 195.3 282 195.3 282 185.8 272.6 185.8" />
          <polygon points="272.6 182.9 282 182.9 282 173.4 272.6 173.4" />
          <polygon points="272.6 170.5 282 170.5 282 161.1 272.6 161.1" />
          <polygon points="272.6 158.1 282 158.1 282 148.7 272.6 148.7" />
          <polygon points="272.6 145.8 282 145.8 282 136.3 272.6 136.3" />
          <polygon points="272.6 133.4 282 133.4 282 123.9 272.6 123.9" />
          <polygon points="272.6 121 282 121 282 111.5 272.6 111.5" />
          <polygon points="272.6 108.6 282 108.6 282 99.1 272.6 99.1" />
          <polygon points="272.6 96.2 282 96.2 282 86.7 272.6 86.7" />
          <polygon points="260.2 207.7 269.6 207.7 269.6 198.2 260.2 198.2" />
          <polygon points="260.2 195.3 269.6 195.3 269.6 185.8 260.2 185.8" />
          <polygon points="260.2 182.9 269.6 182.9 269.6 173.4 260.2 173.4" />
          <polygon points="260.2 170.5 269.6 170.5 269.6 161.1 260.2 161.1" />
          <polygon points="260.2 158.1 269.6 158.1 269.6 148.7 260.2 148.7" />
          <polygon points="260.2 145.8 269.6 145.8 269.6 136.3 260.2 136.3" />
          <polygon points="260.2 133.4 269.6 133.4 269.6 123.9 260.2 123.9" />
          <polygon points="260.2 121 269.6 121 269.6 111.5 260.2 111.5" />
          <polygon points="260.2 108.6 269.6 108.6 269.6 99.1 260.2 99.1" />
          <polygon points="260.2 96.2 269.6 96.2 269.6 86.7 260.2 86.7" />
          <polygon points="247.8 207.7 257.3 207.7 257.3 198.2 247.8 198.2" />
          <polygon points="247.8 195.3 257.3 195.3 257.3 185.8 247.8 185.8" />
          <polygon points="247.8 182.9 257.3 182.9 257.3 173.4 247.8 173.4" />
          <polygon points="247.8 170.5 257.3 170.5 257.3 161.1 247.8 161.1" />
          <polygon points="247.8 158.1 257.3 158.1 257.3 148.7 247.8 148.7" />
          <polygon points="247.8 145.8 257.3 145.8 257.3 136.3 247.8 136.3" />
          <polygon points="247.8 133.4 257.3 133.4 257.3 123.9 247.8 123.9" />
          <polygon points="247.8 121 257.3 121 257.3 111.5 247.8 111.5" />
          <polygon points="247.8 108.6 257.3 108.6 257.3 99.1 247.8 99.1" />
          <polygon points="247.8 96.2 257.3 96.2 257.3 86.7 247.8 86.7" />
          <polygon points="235.4 207.7 244.9 207.7 244.9 198.2 235.4 198.2" />
          <polygon points="235.4 195.3 244.9 195.3 244.9 185.8 235.4 185.8" />
          <polygon points="235.4 182.9 244.9 182.9 244.9 173.4 235.4 173.4" />
          <polygon points="235.4 170.5 244.9 170.5 244.9 161.1 235.4 161.1" />
          <polygon points="235.4 158.1 244.9 158.1 244.9 148.7 235.4 148.7" />
          <polygon points="235.4 145.8 244.9 145.8 244.9 136.3 235.4 136.3" />
          <polygon points="235.4 133.4 244.9 133.4 244.9 123.9 235.4 123.9" />
          <polygon points="235.4 121 244.9 121 244.9 111.5 235.4 111.5" />
          <polygon points="235.4 108.6 244.9 108.6 244.9 99.1 235.4 99.1" />
          <polygon points="235.4 96.2 244.9 96.2 244.9 86.7 235.4 86.7" />
          <polygon points="223 207.7 232.5 207.7 232.5 198.2 223 198.2" />
          <polygon points="223 195.3 232.5 195.3 232.5 185.8 223 185.8" />
          <polygon points="223 182.9 232.5 182.9 232.5 173.4 223 173.4" />
          <polygon points="223 170.5 232.5 170.5 232.5 161.1 223 161.1" />
          <polygon points="223 158.1 232.5 158.1 232.5 148.7 223 148.7" />
          <polygon points="223 145.8 232.5 145.8 232.5 136.3 223 136.3" />
          <polygon points="223 133.4 232.5 133.4 232.5 123.9 223 123.9" />
          <polygon points="223 121 232.5 121 232.5 111.5 223 111.5" />
          <polygon points="223 108.6 232.5 108.6 232.5 99.1 223 99.1" />
          <polygon points="223 96.2 232.5 96.2 232.5 86.7 223 86.7" />
          <polygon points="210.6 207.7 220.1 207.7 220.1 198.2 210.6 198.2" />
          <polygon points="210.6 195.3 220.1 195.3 220.1 185.8 210.6 185.8" />
          <polygon points="210.6 182.9 220.1 182.9 220.1 173.4 210.6 173.4" />
          <polygon points="210.6 170.5 220.1 170.5 220.1 161.1 210.6 161.1" />
          <polygon points="210.6 158.1 220.1 158.1 220.1 148.7 210.6 148.7" />
          <polygon points="210.6 145.8 220.1 145.8 220.1 136.3 210.6 136.3" />
          <polygon points="210.6 133.4 220.1 133.4 220.1 123.9 210.6 123.9" />
          <polygon points="210.6 121 220.1 121 220.1 111.5 210.6 111.5" />
          <polygon points="210.6 108.6 220.1 108.6 220.1 99.1 210.6 99.1" />
          <polygon points="210.6 96.2 220.1 96.2 220.1 86.7 210.6 86.7" />
          <polygon points="198.2 207.7 207.7 207.7 207.7 198.2 198.2 198.2" />
          <polygon points="198.2 195.3 207.7 195.3 207.7 185.8 198.2 185.8" />
          <polygon points="198.2 182.9 207.7 182.9 207.7 173.4 198.2 173.4" />
          <polygon points="198.2 170.5 207.7 170.5 207.7 161.1 198.2 161.1" />
          <polygon points="198.2 158.1 207.7 158.1 207.7 148.7 198.2 148.7" />
          <polygon points="198.2 145.8 207.7 145.8 207.7 136.3 198.2 136.3" />
          <polygon points="198.2 133.4 207.7 133.4 207.7 123.9 198.2 123.9" />
          <polygon points="198.2 121 207.7 121 207.7 111.5 198.2 111.5" />
          <polygon points="198.2 108.6 207.7 108.6 207.7 99.1 198.2 99.1" />
          <polygon points="198.2 96.2 207.7 96.2 207.7 86.7 198.2 86.7" />
          <polygon points="185.8 207.7 195.3 207.7 195.3 198.2 185.8 198.2" />
          <polygon points="185.8 195.3 195.3 195.3 195.3 185.8 185.8 185.8" />
          <polygon points="185.8 182.9 195.3 182.9 195.3 173.4 185.8 173.4" />
          <polygon points="185.8 170.5 195.3 170.5 195.3 161.1 185.8 161.1" />
          <polygon points="185.8 158.1 195.3 158.1 195.3 148.7 185.8 148.7" />
          <polygon points="185.8 145.8 195.3 145.8 195.3 136.3 185.8 136.3" />
          <polygon points="185.8 133.4 195.3 133.4 195.3 123.9 185.8 123.9" />
          <polygon points="185.8 121 195.3 121 195.3 111.5 185.8 111.5" />
          <polygon points="185.8 108.6 195.3 108.6 195.3 99.1 185.8 99.1" />
          <polygon points="185.8 96.2 195.3 96.2 195.3 86.7 185.8 86.7" />
          <polygon points="173.4 207.7 182.9 207.7 182.9 198.2 173.4 198.2" />
          <polygon points="173.4 195.3 182.9 195.3 182.9 185.8 173.4 185.8" />
          <polygon points="173.4 182.9 182.9 182.9 182.9 173.4 173.4 173.4" />
          <polygon points="173.4 170.5 182.9 170.5 182.9 161.1 173.4 161.1" />
          <polygon points="173.4 158.1 182.9 158.1 182.9 148.7 173.4 148.7" />
          <polygon points="173.4 145.8 182.9 145.8 182.9 136.3 173.4 136.3" />
          <polygon points="173.4 133.4 182.9 133.4 182.9 123.9 173.4 123.9" />
          <polygon points="173.4 121 182.9 121 182.9 111.5 173.4 111.5" />
          <polygon points="173.4 108.6 182.9 108.6 182.9 99.1 173.4 99.1" />
          <polygon points="173.4 96.2 182.9 96.2 182.9 86.7 173.4 86.7" />
          <polygon points="161.1 207.7 170.5 207.7 170.5 198.2 161.1 198.2" />
          <polygon points="161.1 195.3 170.5 195.3 170.5 185.8 161.1 185.8" />
          <polygon points="161.1 182.9 170.5 182.9 170.5 173.4 161.1 173.4" />
          <polygon points="161.1 170.5 170.5 170.5 170.5 161.1 161.1 161.1" />
          <polygon points="161.1 158.1 170.5 158.1 170.5 148.7 161.1 148.7" />
          <polygon points="161.1 145.8 170.5 145.8 170.5 136.3 161.1 136.3" />
          <polygon points="161.1 133.4 170.5 133.4 170.5 123.9 161.1 123.9" />
          <polygon points="161.1 121 170.5 121 170.5 111.5 161.1 111.5" />
          <polygon points="161.1 108.6 170.5 108.6 170.5 99.1 161.1 99.1" />
          <polygon points="161.1 96.2 170.5 96.2 170.5 86.7 161.1 86.7" />
          <polygon points="198.1 9.5 207.6 9.5 207.6 0 198.1 0" />
          <polygon points="185.8 9.5 195.3 9.5 195.3 0 185.8 0" />
          <polygon points="148.7 207.7 158.1 207.7 158.1 198.2 148.7 198.2" />
          <polygon points="148.7 195.3 158.1 195.3 158.1 185.8 148.7 185.8" />
          <polygon points="148.7 182.9 158.1 182.9 158.1 173.4 148.7 173.4" />
          <polygon points="148.7 170.5 158.1 170.5 158.1 161.1 148.7 161.1" />
          <polygon points="148.7 158.1 158.1 158.1 158.1 148.7 148.7 148.7" />
          <polygon points="148.7 145.8 158.1 145.8 158.1 136.3 148.7 136.3" />
          <polygon points="148.7 133.4 158.1 133.4 158.1 123.9 148.7 123.9" />
          <polygon points="148.7 121 158.1 121 158.1 111.5 148.7 111.5" />
          <polygon points="148.7 108.6 158.1 108.6 158.1 99.1 148.7 99.1" />
          <polygon points="148.7 96.2 158.1 96.2 158.1 86.7 148.7 86.7" />
          <polygon points="210.6 21.9 220.1 21.9 220.1 12.4 210.6 12.4" />
          <polygon points="198.2 21.9 207.7 21.9 207.7 12.4 198.2 12.4" />
          <polygon points="185.8 21.9 195.3 21.9 195.3 12.4 185.8 12.4" />
          <polygon points="173.4 21.9 182.9 21.9 182.9 12.4 173.4 12.4" />
          <polygon points="136.3 207.7 145.8 207.7 145.8 198.2 136.3 198.2" />
          <polygon points="136.3 195.3 145.8 195.3 145.8 185.8 136.3 185.8" />
          <polygon points="136.3 182.9 145.8 182.9 145.8 173.4 136.3 173.4" />
          <polygon points="136.3 170.5 145.8 170.5 145.8 161.1 136.3 161.1" />
          <polygon points="136.3 158.1 145.8 158.1 145.8 148.7 136.3 148.7" />
          <polygon points="136.3 145.8 145.8 145.8 145.8 136.3 136.3 136.3" />
          <polygon points="136.3 133.4 145.8 133.4 145.8 123.9 136.3 123.9" />
          <polygon points="136.3 121 145.8 121 145.8 111.5 136.3 111.5" />
          <polygon points="136.3 108.6 145.8 108.6 145.8 99.1 136.3 99.1" />
          <polygon points="136.3 96.2 145.8 96.2 145.8 86.7 136.3 86.7" />
          <polygon points="223 34.3 232.5 34.3 232.5 24.8 223 24.8" />
          <polygon points="210.6 34.3 220.1 34.3 220.1 24.8 210.6 24.8" />
          <polygon points="198.1 34.3 207.6 34.3 207.6 24.8 198.1 24.8" />
          <polygon points="185.8 34.3 195.3 34.3 195.3 24.8 185.8 24.8" />
          <polygon points="173.4 34.3 182.9 34.3 182.9 24.8 173.4 24.8" />
          <polygon points="161.1 34.3 170.5 34.3 170.5 24.8 161.1 24.8" />
          <polygon points="123.9 207.7 133.4 207.7 133.4 198.2 123.9 198.2" />
          <polygon points="123.9 195.3 133.4 195.3 133.4 185.8 123.9 185.8" />
          <polygon points="123.9 182.9 133.4 182.9 133.4 173.4 123.9 173.4" />
          <polygon points="123.9 170.5 133.4 170.5 133.4 161.1 123.9 161.1" />
          <polygon points="123.9 158.1 133.4 158.1 133.4 148.7 123.9 148.7" />
          <polygon points="123.9 145.8 133.4 145.8 133.4 136.3 123.9 136.3" />
          <polygon points="123.9 133.4 133.4 133.4 133.4 123.9 123.9 123.9" />
          <polygon points="123.9 121 133.4 121 133.4 111.5 123.9 111.5" />
          <polygon points="123.9 108.6 133.4 108.6 133.4 99.1 123.9 99.1" />
          <polygon points="123.9 96.2 133.4 96.2 133.4 86.7 123.9 86.7" />
          <polygon points="247.8 46.6 257.3 46.6 257.3 37.2 247.8 37.2" />
          <polygon points="235.4 46.6 244.9 46.6 244.9 37.2 235.4 37.2" />
          <polygon points="223 46.6 232.5 46.6 232.5 37.2 223 37.2" />
          <polygon points="210.6 46.6 220.1 46.6 220.1 37.2 210.6 37.2" />
          <polygon points="198.2 46.6 207.7 46.6 207.7 37.2 198.2 37.2" />
          <polygon points="185.8 46.6 195.3 46.6 195.3 37.2 185.8 37.2" />
          <polygon points="173.4 46.6 182.9 46.6 182.9 37.2 173.4 37.2" />
          <polygon points="161.1 46.6 170.5 46.6 170.5 37.2 161.1 37.2" />
          <polygon points="148.7 46.6 158.1 46.6 158.1 37.2 148.7 37.2" />
          <polygon points="136.3 46.6 145.8 46.6 145.8 37.2 136.3 37.2" />
          <polygon points="111.5 207.7 121 207.7 121 198.2 111.5 198.2" />
          <polygon points="111.5 195.3 121 195.3 121 185.8 111.5 185.8" />
          <polygon points="111.5 182.9 121 182.9 121 173.4 111.5 173.4" />
          <polygon points="111.5 170.5 121 170.5 121 161.1 111.5 161.1" />
          <polygon points="111.5 158.1 121 158.1 121 148.7 111.5 148.7" />
          <polygon points="111.5 145.8 121 145.8 121 136.3 111.5 136.3" />
          <polygon points="111.5 133.4 121 133.4 121 123.9 111.5 123.9" />
          <polygon points="111.5 121 121 121 121 111.5 111.5 111.5" />
          <polygon points="111.5 108.6 121 108.6 121 99.1 111.5 99.1" />
          <polygon points="111.5 96.2 121 96.2 121 86.7 111.5 86.7" />
          <polygon points="260.2 59 269.6 59 269.6 49.6 260.2 49.6" />
          <polygon points="247.8 59 257.3 59 257.3 49.6 247.8 49.6" />
          <polygon points="235.4 59 244.9 59 244.9 49.6 235.4 49.6" />
          <polygon points="223 59 232.5 59 232.5 49.6 223 49.6" />
          <polygon points="210.6 59 220.1 59 220.1 49.6 210.6 49.6" />
          <polygon points="198.2 59 207.7 59 207.7 49.6 198.2 49.6" />
          <polygon points="185.8 59 195.3 59 195.3 49.6 185.8 49.6" />
          <polygon points="173.4 59 182.9 59 182.9 49.6 173.4 49.6" />
          <polygon points="161.1 59 170.5 59 170.5 49.6 161.1 49.6" />
          <polygon points="148.7 59 158.1 59 158.1 49.6 148.7 49.6" />
          <polygon points="136.3 59 145.8 59 145.8 49.6 136.3 49.6" />
          <polygon points="123.9 59 133.4 59 133.4 49.6 123.9 49.6" />
          <polygon points="99.1 207.7 108.6 207.7 108.6 198.2 99.1 198.2" />
          <polygon points="99.1 195.3 108.6 195.3 108.6 185.8 99.1 185.8" />
          <polygon points="99.1 182.9 108.6 182.9 108.6 173.4 99.1 173.4" />
          <polygon points="99.1 170.5 108.6 170.5 108.6 161.1 99.1 161.1" />
          <polygon points="99.1 158.1 108.6 158.1 108.6 148.7 99.1 148.7" />
          <polygon points="99.1 145.8 108.6 145.8 108.6 136.3 99.1 136.3" />
          <polygon points="99.1 133.4 108.6 133.4 108.6 123.9 99.1 123.9" />
          <polygon points="99.1 121 108.6 121 108.6 111.5 99.1 111.5" />
          <polygon points="99.1 108.6 108.6 108.6 108.6 99.1 99.1 99.1" />
          <polygon points="99.1 96.2 108.6 96.2 108.6 86.7 99.1 86.7" />
          <polygon points="272.6 71.4 282 71.4 282 61.9 272.6 61.9" />
          <polygon points="260.2 71.4 269.6 71.4 269.6 61.9 260.2 61.9" />
          <polygon points="247.8 71.4 257.3 71.4 257.3 61.9 247.8 61.9" />
          <polygon points="235.4 71.4 244.9 71.4 244.9 61.9 235.4 61.9" />
          <polygon points="223 71.4 232.5 71.4 232.5 61.9 223 61.9" />
          <polygon points="210.6 71.4 220.1 71.4 220.1 61.9 210.6 61.9" />
          <polygon points="198.2 71.4 207.7 71.4 207.7 61.9 198.2 61.9" />
          <polygon points="185.8 71.4 195.3 71.4 195.3 61.9 185.8 61.9" />
          <polygon points="173.4 71.4 182.9 71.4 182.9 61.9 173.4 61.9" />
          <polygon points="161.1 71.4 170.5 71.4 170.5 61.9 161.1 61.9" />
          <polygon points="148.7 71.4 158.1 71.4 158.1 61.9 148.7 61.9" />
          <polygon points="136.3 71.4 145.8 71.4 145.8 61.9 136.3 61.9" />
          <polygon points="123.9 71.4 133.4 71.4 133.4 61.9 123.9 61.9" />
          <polygon points="111.5 71.4 121 71.4 121 61.9 111.5 61.9" />
          <polygon points="86.7 207.7 96.2 207.7 96.2 198.2 86.7 198.2" />
          <polygon points="86.7 195.3 96.2 195.3 96.2 185.8 86.7 185.8" />
          <polygon points="86.7 182.9 96.2 182.9 96.2 173.4 86.7 173.4" />
          <polygon points="86.7 170.5 96.2 170.5 96.2 161.1 86.7 161.1" />
          <polygon points="86.7 158.1 96.2 158.1 96.2 148.7 86.7 148.7" />
          <polygon points="86.7 145.8 96.2 145.8 96.2 136.3 86.7 136.3" />
          <polygon points="86.7 133.4 96.2 133.4 96.2 123.9 86.7 123.9" />
          <polygon points="86.7 121 96.2 121 96.2 111.5 86.7 111.5" />
          <polygon points="86.7 108.6 96.2 108.6 96.2 99.1 86.7 99.1" />
          <polygon points="86.7 96.2 96.2 96.2 96.2 86.7 86.7 86.7" />
          <polygon points="284.9 83.8 294.4 83.8 294.4 74.3 284.9 74.3" />
          <polygon points="272.6 83.8 282 83.8 282 74.3 272.6 74.3" />
          <polygon points="260.2 83.8 269.6 83.8 269.6 74.3 260.2 74.3" />
          <polygon points="247.8 83.8 257.3 83.8 257.3 74.3 247.8 74.3" />
          <polygon points="235.4 83.8 244.9 83.8 244.9 74.3 235.4 74.3" />
          <polygon points="223 83.8 232.5 83.8 232.5 74.3 223 74.3" />
          <polygon points="210.6 83.8 220.1 83.8 220.1 74.3 210.6 74.3" />
          <polygon points="198.2 83.8 207.7 83.8 207.7 74.3 198.2 74.3" />
          <polygon points="185.8 83.8 195.3 83.8 195.3 74.3 185.8 74.3" />
          <polygon points="173.4 83.8 182.9 83.8 182.9 74.3 173.4 74.3" />
          <polygon points="161.1 83.8 170.5 83.8 170.5 74.3 161.1 74.3" />
          <polygon points="148.7 83.8 158.1 83.8 158.1 74.3 148.7 74.3" />
          <polygon points="136.3 83.8 145.8 83.8 145.8 74.3 136.3 74.3" />
          <polygon points="123.9 83.8 133.4 83.8 133.4 74.3 123.9 74.3" />
          <polygon points="111.5 83.8 121 83.8 121 74.3 111.5 74.3" />
          <polygon points="99.1 83.8 108.6 83.8 108.6 74.3 99.1 74.3" />
          <polygon points="74.3 207.7 83.8 207.7 83.8 198.2 74.3 198.2" />
          <polygon points="74.3 195.3 83.8 195.3 83.8 185.8 74.3 185.8" />
          <polygon points="74.3 182.9 83.8 182.9 83.8 173.4 74.3 173.4" />
          <polygon points="74.3 170.5 83.8 170.5 83.8 161.1 74.3 161.1" />
          <polygon points="74.3 158.1 83.8 158.1 83.8 148.7 74.3 148.7" />
          <polygon points="74.3 145.8 83.8 145.8 83.8 136.3 74.3 136.3" />
          <polygon points="74.3 133.4 83.8 133.4 83.8 123.9 74.3 123.9" />
          <polygon points="74.3 121 83.8 121 83.8 111.5 74.3 111.5" />
          <polygon points="74.3 108.6 83.8 108.6 83.8 99.1 74.3 99.1" />
          <polygon points="61.9 207.7 71.4 207.7 71.4 198.2 61.9 198.2" />
          <polygon points="61.9 195.3 71.4 195.3 71.4 185.8 61.9 185.8" />
          <polygon points="61.9 182.9 71.4 182.9 71.4 173.4 61.9 173.4" />
          <polygon points="61.9 170.5 71.4 170.5 71.4 161.1 61.9 161.1" />
          <polygon points="61.9 158.1 71.4 158.1 71.4 148.7 61.9 148.7" />
          <polygon points="61.9 145.8 71.4 145.8 71.4 136.3 61.9 136.3" />
          <polygon points="61.9 133.4 71.4 133.4 71.4 123.9 61.9 123.9" />
          <polygon points="61.9 121 71.4 121 71.4 111.5 61.9 111.5" />
          <polygon points="49.6 207.7 59 207.7 59 198.2 49.6 198.2" />
          <polygon points="49.6 195.3 59 195.3 59 185.8 49.6 185.8" />
          <polygon points="49.6 182.9 59 182.9 59 173.4 49.6 173.4" />
          <polygon points="49.6 170.5 59 170.5 59 161.1 49.6 161.1" />
          <polygon points="49.6 158.1 59 158.1 59 148.7 49.6 148.7" />
          <polygon points="49.6 145.8 59 145.8 59 136.3 49.6 136.3" />
          <polygon points="49.6 133.4 59 133.4 59 123.9 49.6 123.9" />
          <polygon points="37.2 207.7 46.6 207.7 46.6 198.2 37.2 198.2" />
          <polygon points="37.2 195.3 46.6 195.3 46.6 185.8 37.2 185.8" />
          <polygon points="37.2 182.9 46.6 182.9 46.6 173.4 37.2 173.4" />
          <polygon points="37.2 170.5 46.6 170.5 46.6 161.1 37.2 161.1" />
          <polygon points="37.2 158.1 46.6 158.1 46.6 148.7 37.2 148.7" />
          <polygon points="37.2 145.8 46.6 145.8 46.6 136.3 37.2 136.3" />
          <polygon points="24.8 207.7 34.3 207.7 34.3 198.2 24.8 198.2" />
          <polygon points="24.8 195.3 34.3 195.3 34.3 185.8 24.8 185.8" />
          <polygon points="24.8 182.9 34.3 182.9 34.3 173.4 24.8 173.4" />
          <polygon points="24.8 170.5 34.3 170.5 34.3 161.1 24.8 161.1" />
          <polygon points="24.8 158.1 34.3 158.1 34.3 148.7 24.8 148.7" />
          <polygon points="12.4 207.7 21.9 207.7 21.9 198.2 12.4 198.2" />
          <polygon points="12.4 195.3 21.9 195.3 21.9 185.8 12.4 185.8" />
          <polygon points="12.4 182.9 21.9 182.9 21.9 173.4 12.4 173.4" />
          <polygon points="12.4 170.5 21.9 170.5 21.9 161.1 12.4 161.1" />
          <polygon points="0 207.7 9.5 207.7 9.5 198.2 0 198.2" />
          <polygon points="0 195.3 9.5 195.3 9.5 185.8 0 185.8" />
          <polygon points="0 182.9 9.5 182.9 9.5 173.4 0 173.4" />
        </g>
      </g>
    </svg>
  );

  return (
    <div id="strong-healthy-homes">
      <div className="bg-wrapper-vision">
        <div className="vision">
          <h1>
            {Locale.title}
          </h1>
          <div className="text-box">
            {Locale.visionTitle}
          </div>
          <h3>
            {Locale.visionSubHeader}
          </h3>
          <div
            className="vision-body"
            dangerouslySetInnerHTML={{ __html: Locale.visionBody }}
          />
        </div>
      </div>
      <div className="bg-wrapper-visual-datapoint">
        <div className="visual-datapoint">
          <div
            className="data"
            dangerouslySetInnerHTML={{ __html: Locale.datapoint }}
          />
          {graphic}
        </div>
      </div>
      <Goals
        items={Locale.goals}
        setGoalsView={setGoalsView}
      />
    </div>
  );
};

StrongHealthyHomes.propTypes = {
  setGoalsView: PropTypes.func.isRequired
};

export default StrongHealthyHomes;
